<template>
  <div class="sidebar">
    <!-- Brand / logo block, height-matched to navbar -->
    <div class="logo-container">
      <div class="logo-mark">月</div>
      <h1 class="logo-title">月安选管理</h1>
    </div>

    <el-menu
      :default-active="activeMenu"
      background-color="#1a2332"
      text-color="#a8b2c1"
      active-text-color="#ffffff"
      :unique-opened="true"
      class="sidebar-menu el-menu--dark"
      router
    >
      <el-menu-item index="/dashboard">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>

      <el-menu-item index="/institution">
        <i class="el-icon-office-building"></i>
        <span slot="title">机构管理</span>
      </el-menu-item>

      <el-menu-item index="/content/review">
        <i class="el-icon-document-checked"></i>
        <span slot="title">内容审核</span>
      </el-menu-item>

      <el-submenu index="order">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>订单管理</span>
        </template>
        <el-menu-item index="/order/list">订单列表</el-menu-item>
        <el-menu-item index="/order/refund">退款审核</el-menu-item>
      </el-submenu>

      <el-menu-item index="/user/list">
        <i class="el-icon-user"></i>
        <span slot="title">用户管理</span>
      </el-menu-item>

      <el-submenu index="system">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item index="/system/admin">管理员管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  computed: {
    activeMenu() {
      const { path } = this.$route
      // For institution edit pages, highlight the institution list
      if (path.startsWith('/institution/edit')) {
        return '/institution'
      }
      return path
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.sidebar {
  height: 100%;
  background-color: $sidebar-bg;
  display: flex;
  flex-direction: column;
}

// -----------------------------------------------------------------------------
// Brand block — sits flush with the navbar (same 56px height) and uses the
// darker logo background to create a subtle two-tone vertical seam.
// -----------------------------------------------------------------------------
.logo-container {
  height: $navbar-height;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $sidebar-logo-bg;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  user-select: none;
}

.logo-mark {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  box-shadow: 0 2px 6px rgba(74, 123, 247, 0.35);
  letter-spacing: 0;
}

.logo-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  margin: 0;
  white-space: nowrap;
}

// -----------------------------------------------------------------------------
// Menu — overrides scoped to the sidebar so they don't fight global.scss.
// Uses ::v-deep so we can reach Element UI internals from a scoped block.
// -----------------------------------------------------------------------------
.sidebar-menu {
  border-right: none;
  flex: 1;
  padding-top: 8px;

  ::v-deep .el-menu-item,
  ::v-deep .el-submenu__title {
    height: 48px;
    line-height: 48px;
    padding-left: 20px !important;
    font-size: 14px;
    color: $sidebar-text;
    transition: $transition-base;

    i {
      color: $sidebar-text;
      margin-right: 8px;
      transition: $transition-base;
    }

    &:hover {
      background-color: $sidebar-hover-bg !important;
      color: $sidebar-active-text;

      i {
        color: $sidebar-active-text;
      }
    }
  }

  // Active leaf item — left accent rail + tinted background.
  ::v-deep .el-menu-item.is-active {
    color: $sidebar-active-text;
    background-color: $sidebar-active-bg !important;
    border-left: 3px solid $primary-color;
    // Compensate the 3px we just consumed so labels don't shift.
    padding-left: 17px !important;

    i {
      color: $primary-light;
    }
  }

  ::v-deep .el-submenu.is-active > .el-submenu__title {
    color: $sidebar-active-text;

    i {
      color: $primary-light;
    }
  }

  // Nested items — slightly darker shade so the hierarchy is legible.
  ::v-deep .el-menu--inline {
    background-color: #151d29 !important;

    .el-menu-item {
      height: 44px;
      line-height: 44px;
      padding-left: 48px !important;
      background-color: #151d29 !important;
      font-size: 13px;

      &:hover {
        background-color: $sidebar-hover-bg !important;
      }

      &.is-active {
        background-color: $sidebar-active-bg !important;
        border-left: 3px solid $primary-color;
        padding-left: 45px !important;
      }
    }
  }
}
</style>
